// The Main Site Object
window.Site = {

    wrapper : document.querySelector('.wrapper'),
    footer  : document.querySelector('.footer'),

    newsletterButtons : document.querySelectorAll('.footer-text a, .contacts .substack'),
    newsletterOverlay : document.querySelector('.newsletter-overlay'),

    // Init Function
    liftoff : () => {
        Site.addCustomMarginBottom()
        Site.showNewsletterOverlay()
        Site.hideNewsletterOverlay()
    },

    addCustomMarginBottom : () => {

        // If we don't have one of the two elements we don't need to do anything
        if (!Site.wrapper || !Site.footer) return;

        function addMargin () {
            Site.wrapper.style.marginBottom = `${Site.footer.clientHeight}px`
        }

        window.addEventListener('load' , () => {addMargin()})
        window.addEventListener('resize' , () => {addMargin()})

    },

    // Show Overlay on Click
    showNewsletterOverlay : () => {

        Site.newsletterButtons.forEach(button => {

            button.addEventListener('click' , event => {

                event.preventDefault()
                Site.newsletterOverlay.classList.add('visible')

            })

        })

    },

    hideNewsletterOverlay : () => {
        Site.newsletterOverlay.addEventListener('click' , event => {

            if (event.target == Site.newsletterOverlay && Site.newsletterOverlay.classList.contains('visible'))
                Site.newsletterOverlay.classList.remove('visible')

        })
    }


}

// Launch The Script
Site.liftoff()